import request from "utils/request";

export default {
  adminLogin: request("post", "/api/kiosk/login"), // 어드민 키오스크 로그인
  getFestival: request("get", "/api/v1/kiosk/branch"), // 페스티벌 정보 조회
  getBranchList: request("get", "/api/v1/kiosk/:id/branchMenuTypes"), // 대카테고리 목록 조회
  getBranchMenuList: request("get", "/api/v1/kiosk/:id/branchMenus"), // 중, 소카테고리 목록 조회
  getProductList: request("get", "/api/v1/kiosk/menus"), // 상품 목록 조회
  getProductDetail: request("get", "/api/v1/kiosk/menus/:id"), // 상품 상세 조회
  getTimeline: request("get", "/api/v1/kiosk/menus/:id/timeline"), // 시간 상품 시간대 데이터 조회

  // 2025-07-11 추가
  simplePay: request("post", "/api/v1/kiosk-payment/simple-pay"), // 키오스크 - 간편결제 (orderId, barcode + method)

  complete: request("post", "/api/v1/kiosk-payment/complete"), //키오스크 - 결제 승인
  completeCash: request("post", "/api/v1/kiosk-payment/complete-cash"), //키오스크 - 현금결제 후처리
  payment: request("post", "/api/v1/kiosk-payment"), //키오스크 - 결제
  addNormal: request("post", "/api/v2/carts/normal"), //키오스크 (normal)주문 상품보기
  addTimeMain: request("post", "/api/v2/carts/time/main"), //키오스크 (normal)주문 상품보기
  addTimeType: request("post", "/api/v2/carts/time/type"), //키오스크 (normal)주문 상품보기
  // getMenuDates: request("get", "/api/menus/:id/menutimes/date"), //시간 상품별 날짜 목록
  getCart: request("get", "/api/v2/carts"), //시간 상품별 날짜 목록
  removeOne: request("delete", "/api/v2/carts/:id"), //키오스크 단일 주문 삭제
  removeAll: request("delete", "/api/v2/carts/kiosk-all"), //키오스크 주문 전체 삭제
  fastestSingle: request(
    "get",
    "/api/v1/carts/first-order-menus/time/main/kiosk"
  ), //키오스크 주문 전체 삭제
  fastestType: request(
    "get",
    "/api/v1/carts/first-order-menus/time/type/kiosk"
  ), //키오스크 주문 전체 삭제
  updateCount: request("post", "/api/v2/carts/update-count/:id"), //키오스크 장바구니 상품 수량 증감

  ad: request("get", "/api/v1/ad/:id", { uselessAuth: true }),

  getTerm: request("get", "/api/v1/documents,",{ uselessAuth: true }), // 키오스크 약관 조회
};
